/**
 * Components
 */

import {
	Button,
	Details,
	TabGroup,
	List,
	MediaGallery,
	// Jumplist,
	Player,
	// GMap,
	// ProgressBar,
	// ProgressRing,
	// Reveal,
	// RevealPassword,
	// ScrollProgress,
	Tag
} from '@ifabnpm/bootstrap/components.js';

import Slider from './shared/slider';
import Form from './shared/form';
import ContentBox from './custom/content-box';
import Table from './shared/table';

// ------
// Public
// ------

const index = () => {
	Button.init();
	Details.init();
	TabGroup.init();
	Slider.init();
	Form.init();
	ContentBox.init();
	// Jumplist.init();
	List.init();
	MediaGallery.init(null, {
		slider: {
			grabCursor: true,
			lazyPreloadPrevNext: 1,
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 0
		}
	});
	Player.init({
		audio: {
			volume: 0.5
		},
		video: {
			volume: 0.5
		}
	});
	// ProgressBar.init();
	// ProgressRing.init();
	// Reveal.init();
	// RevealPassword.init();
	// ScrollProgress.init();
	Tag.init();
	Table.makeScrollable();

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	// GMap.init(null, {
	// 	apiKey  : window.pageInstance.settings.maps.google.id,
	// 	settings: {
	// 		// Siehe google-maps.js -> DEFAULTS
	// 		map: {
	// 			zoom: 14
	// 		}
	// 	}
	// });
	// }
};

// Export
export default index;
